import { render, staticRenderFns } from "./BviLogo.vue?vue&type=template&id=48433819&scoped=true"
import script from "./BviLogo.vue?vue&type=script&lang=js"
export * from "./BviLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48433819",
  null
  
)

export default component.exports